// extracted by mini-css-extract-plugin
export default {"formGrid":"styles_formGrid__6S+wC","buttonContainer":"styles_buttonContainer__XCC4P","switchContainer":"styles_switchContainer__+W4Fv","switchItem":"styles_switchItem__clahY"};